<script setup>
/* global axios */
// Inserção de variáveis {{...}} — vars de sistema + variáveis de flow da conta (custom) + busca.
import { ref, computed, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['select']);
const { t } = useI18n();
const aux = inject('flowAux', {});
const open = ref(false);
const search = ref('');
const custom = ref([]);

const SYSTEM = [
  { key: 'contato', desc: 'CHATBOT.variablePicker.system.contato' },
  { key: 'senderName', desc: 'CHATBOT.variablePicker.system.senderName' },
  { key: 'message', desc: 'CHATBOT.variablePicker.system.message' },
  { key: 'contactEmail', desc: 'CHATBOT.variablePicker.system.contactEmail' },
  { key: 'inboxId', desc: 'CHATBOT.variablePicker.system.inboxId' },
  { key: 'response', desc: 'CHATBOT.variablePicker.system.response' },
  { key: 'resposta', desc: 'CHATBOT.variablePicker.system.resposta' },
];
const matches = list =>
  list.filter(v => v.key.toLowerCase().includes(search.value.toLowerCase()));
const filteredSystem = computed(() => matches(SYSTEM));
const filteredCustom = computed(() => matches(custom.value));

const braced = key => `{{${key}}}`;
const pick = key => {
  emit('select', braced(key));
  open.value = false;
  search.value = '';
};

onMounted(async () => {
  if (!aux.accountId) return;
  try {
    const vars =
      (
        await axios.get(
          `/api/v1/accounts/${aux.accountId}/kanban/flow_variables`
        )
      ).data.data || [];
    custom.value = vars.map(v => ({ key: v.name, desc: v.description || '' }));
  } catch (e) {
    custom.value = [];
  }
});
</script>

<template>
  <div class="relative inline-block">
    <button
      type="button"
      class="text-[0.6875rem] text-n-blue-11 hover:underline"
      @click="open = !open"
    >
      {{ t('CHATBOT.variablePicker.insert') }}
    </button>
    <div
      v-if="open"
      class="absolute right-0 z-20 mt-1 bg-n-background border rounded-lg shadow-lg w-56 border-n-weak"
    >
      <input
        v-model="search"
        class="w-full px-2 py-1.5 text-xs border-b border-n-weak focus:outline-none"
        :placeholder="t('CHATBOT.variablePicker.search')"
      />
      <div class="py-1 max-h-60 overflow-y-auto">
        <p
          v-if="filteredCustom.length"
          class="px-3 pt-1 pb-0.5 text-[0.625rem] font-semibold uppercase tracking-wider text-n-slate-9"
        >
          {{ t('CHATBOT.variablePicker.yourVariables') }}
        </p>
        <button
          v-for="v in filteredCustom"
          :key="'c-' + v.key"
          type="button"
          class="block w-full px-3 py-1.5 text-left hover:bg-n-alpha-1"
          @click="pick(v.key)"
        >
          <span class="text-xs font-medium text-n-slate-12">{{
            braced(v.key)
          }}</span>
          <span v-if="v.desc" class="block text-[0.625rem] text-n-slate-10">{{
            v.desc
          }}</span>
        </button>
        <p
          class="px-3 pt-1 pb-0.5 text-[0.625rem] font-semibold uppercase tracking-wider text-n-slate-9"
        >
          {{ t('CHATBOT.variablePicker.system.title') }}
        </p>
        <button
          v-for="v in filteredSystem"
          :key="'s-' + v.key"
          type="button"
          class="block w-full px-3 py-1.5 text-left hover:bg-n-alpha-1"
          @click="pick(v.key)"
        >
          <span class="text-xs font-medium text-n-slate-12">{{
            braced(v.key)
          }}</span>
          <span class="block text-[0.625rem] text-n-slate-10">{{
            t(v.desc)
          }}</span>
        </button>
        <p
          v-if="!filteredSystem.length && !filteredCustom.length"
          class="px-3 py-2 text-[0.6875rem] text-n-slate-10"
        >
          {{ t('CHATBOT.variablePicker.empty') }}
        </p>
      </div>
    </div>
  </div>
</template>
